import { render, staticRenderFns } from "./video_detail.vue?vue&type=template&id=6fb5b28e&scoped=true"
import script from "./video_detail.vue?vue&type=script&lang=ts"
export * from "./video_detail.vue?vue&type=script&lang=ts"
import style0 from "./video_detail.vue?vue&type=style&index=0&id=6fb5b28e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fb5b28e",
  null
  
)

export default component.exports